var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScatterChartUp01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scatter-chart-up-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.5 17.5H3.83333C3.36662 17.5 3.13327 17.5 2.95501 17.4092C2.79821 17.3293 2.67072 17.2018 2.59083 17.045C2.5 16.8667 2.5 16.6334 2.5 16.1667V2.5",
    stroke: "#647980",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 8",
    cx: 7.50033,
    cy: 12.5003,
    rx: 0.833333,
    ry: 0.833333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 11",
    cx: 10.0003,
    cy: 9.16634,
    rx: 0.833333,
    ry: 0.833333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 12",
    cx: 5.83333,
    cy: 5.00033,
    rx: 0.833333,
    ry: 0.833333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 14.1663,
    cy: 11.6663,
    r: 0.833333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 9",
    cx: 11.6663,
    cy: 5.83333,
    rx: 0.833333,
    ry: 0.833333,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterChartUp01);
export default __webpack_public_path__ + "static/media/scatter-chart-up-01.3ced412b192f26ceeb576a7687022694.svg";
export { ForwardRef as ReactComponent };